/*************
 * findARetailer
 *
 */

custom.videoAutoplayHandler = (() => {
  // const pdpIdentifierClass = "product-detail";
  // const thumbnailsClass = "product-detail__thumbnails";
  // const imagesClass = "product-detail__images";

  // const vimeoStr = "player.vimeo.com"
  // const onPDP = $(`.${pdpIdentifierClass}`).length;

  const breakpoint = 768;

  function isMobile() {
    return $(window).width() < breakpoint;
  }

  /******************
   * FORM VALIDATION HANDLING
   */
  function play(payload = null) {
    if (!payload) return;
    if ($(payload).find('video').length) {
      //https://developer.chrome.com/blog/play-request-was-interrupted/
      var video = $(payload).find('video').get(0);
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then((_) => {
            // Automatic playback started!
            // Show playing UI.
          })
          .catch((error) => {
            // Auto-play was prevented
            // Show paused UI.
            video.controls = true;
          });
      }
    }
  }

  function responsiveHandler() {
    $('video[data-src-mobile]').each(function () {
      const $video = $(this);
      const src = isMobile()
        ? $video.data('src-mobile')
        : $video.data('src-desktop');
      const $source = $video.find('source');
      // If the source is already set to the correct src, do nothing
      if ($source.attr('src') === src) return;
      $source.attr('src', src);
      this.load();
    });
  }

  function init() {
    const $responsiveVideoExists = $('video[data-src-mobile]');
    if (!$responsiveVideoExists.length) return;
    responsiveHandler();
    $(window).on('resize', responsiveHandler);
  }

  return {
    init,
    play,
  };
})();

custom.videoAutoplayHandler.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/video-autoplay-handler.js